import { cn } from '@avanta/shared/utils/cn';

interface SessionSummaryItemProps {
  icon?: React.ElementType;
  img?: string;
  label: string;
  className?: string;
  description?: string;
  containerClassName?: string;
}

export const SessionSummaryItem = ({
  icon: Icon,
  img,
  label,
  className,
  containerClassName,
  description,
}: SessionSummaryItemProps): React.ReactElement => (
  <div className={cn('flex items-center', containerClassName)}>
    {img && <img src={img} alt={label} className="size-4 mr-2" />}
    {Icon && <Icon className="size-4 text-teal-600 shrink-0 mr-2" />}
    <div className="flex flex-col justify-center overflow-visible">
      <p
        className={cn(
          'text-xs am-lg:text-sm text-denim-800 font-normal am-lg:leading-5 leading-4',
          className
        )}
      >
        {label}
      </p>
      {description && <p className="text-xs text-gray-500 leading-4">{description}</p>}
    </div>
  </div>
);
